import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router';
import { Menu, X } from 'lucide-react';
import { ThemeToggle } from '@edupra/shell';
import { Brand } from './brand';
import { APP_URL } from '../lib/config';

const NAV_LINKS = [
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/download', label: 'Download' },
  { to: '/contact', label: 'Contact' },
] as const;

export function SiteNav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      className="sticky top-0 z-40 w-full backdrop-blur"
      style={{
        background: 'var(--bg-glass)',
        borderBottom: '1px solid var(--border-hair)',
      }}
    >
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
        <Brand size={32} weight="medium" />

        <nav className="hidden items-center gap-7 md:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => {
            const active = loc.pathname === l.to;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                className="text-[13px] font-medium transition-colors"
                style={{
                  color: active ? 'var(--fg-high)' : 'var(--fg-mid)',
                  letterSpacing: '-0.005em',
                }}
              >
                {l.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <ThemeToggle />
          <a
            href={APP_URL}
            className="text-[13px] font-medium"
            style={{ color: 'var(--fg-mid)', letterSpacing: '-0.005em' }}
          >
            Sign in
          </a>
          <Link to="/contact" className="ed-btn-primary ed-btn-sm">
            Get a demo
          </Link>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          className="md:hidden flex h-8 w-8 items-center justify-center rounded-md"
          style={{
            color: 'var(--fg-mid)',
            border: '1px solid var(--border-line)',
            background: 'var(--bg-surface)',
          }}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t"
          style={{ borderColor: 'var(--border-hair)', background: 'var(--bg-surface)' }}
        >
          <div className="mx-auto flex max-w-6xl flex-col gap-1 px-6 py-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-2 text-sm font-medium"
                style={{ color: 'var(--fg-high)' }}
              >
                {l.label}
              </NavLink>
            ))}
            <div className="mt-2 flex items-center justify-between border-t pt-3" style={{ borderColor: 'var(--border-hair)' }}>
              <ThemeToggle />
              <div className="flex items-center gap-3">
                <a href={APP_URL} className="text-sm font-medium" style={{ color: 'var(--fg-mid)' }}>
                  Sign in
                </a>
                <Link to="/contact" onClick={() => setOpen(false)} className="ed-btn-primary ed-btn-sm">
                  Get a demo
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
